import { useCallback, useContext, useEffect } from 'react';
import Raven from 'raven-js';
import { useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';

// @ts-expect-error untyped import
import { createMeetingsUser } from '../redux/actions/MeetingsUserActions';
import MeetingsUser from 'MeetingsBase/models/MeetingsUser';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Button } from 'foundations-components/transitional/components/Button';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import UsageTracker, { trackSubScreen } from '../tracking/UsageTracker';

// @ts-expect-error untyped import
import MeetingsZeroStatePreview from './MeetingsZeroStatePreview';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function MeetingsUserZeroState() {
  const dispatch = useDispatch();
  const {
    tour
  } = useContext(TourContext);
  const handleCreateMeetingsUser = useCallback(() => {
    const emptyMeetingsUser = new MeetingsUser();
    dispatch(createMeetingsUser(emptyMeetingsUser)).then(() => {
      UsageTracker.track('activation', {
        step: 'activated'
      });
      tour.start();
    }).catch(error => Raven.captureException(error, {
      extra: {
        message: 'Error creating meetings user'
      }
    }));
  }, [dispatch, tour]);
  useEffect(() => {
    trackSubScreen('meetings-pro-plus-empty-state');
  }, []);
  return /*#__PURE__*/_jsx(EmptyState, {
    maxWidth: 1100,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "meetingsUserZeroState.title"
    }),
    primaryContent: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "meetingsUserZeroState.description"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "meetingsUserZeroState.paragraph"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "primary",
        "data-selenium-test": "create-user",
        onClick: handleCreateMeetingsUser,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "meetingsUserZeroState.primaryAction"
        })
      })]
    }),
    secondaryContent: /*#__PURE__*/_jsx(MeetingsZeroStatePreview, {}),
    secondaryContentWidth: 480
  });
}